import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-deviz',
  templateUrl: './deviz.component.html',
  styleUrls: ['./deviz.component.css']
})
export class DevizComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
